module.exports = __webpack_public_path__ + "img/img23.7b08e9d6.svg";